import { useState, useCallback } from "react";

/**
 * Email obfuscation — the address never appears in raw HTML/source.
 * Bots see an empty span. JS-enabled users see a clickable "Contact" link.
 * The email is assembled from separate fragments at click time only.
 */
export default function ObfuscatedEmail() {
  const [revealed, setRevealed] = useState(false);

  // Split across variables so no single string in the bundle contains the full address
  const u = "hello";
  const d = "skella.com";
  const t = ".au";

  const handleClick = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();
      if (!revealed) {
        setRevealed(true);
      } else {
        window.location.href = `mai${"lt"}o:${u}@${d}${t}`;
      }
    },
    [revealed]
  );

  return (
    <a
      href="#contact"
      onClick={handleClick}
      className="hover:text-foreground transition-colors cursor-pointer"
      data-testid="contact-email"
      aria-label="Contact us"
    >
      {revealed ? `${u}@${d}${t}` : "Contact"}
    </a>
  );
}
